<script lang="ts">
    import { _, t } from "svelte-i18n"
    import { onMount } from "svelte"
    // dont import index.js, because node process dependency (not avail in tibi-server)
    // @ts-ignore
    import { loadScript } from "@paypal/paypal-js/dist/esm/paypal-js"
    import type { loadScript as loadScriptT } from "@paypal/paypal-js"
    import { cart, checkoutData, getAsyncCartSum } from "../../../functionTools/cart"

    import { postPayment, reportFrontendError, errorCodeFrom } from "../../../api"
    import CheckoutErrorBox from "./CheckoutErrorBox.svelte"
    import {
        currency,
        paypalLiveClientId,
        paypalMode,
        paypalSandboxClientId,
    } from "../../../../../api/hooks/config-client"
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"

    interface Props {
        submitHandler: () => Promise<void>
    }
    let { submitHandler }: Props = $props()
    let ppContainer: HTMLElement = $state()
    let initialized = $state(false)
    let errorCode: string | null = $state(null)

    const paypalLoadScript = loadScript as typeof loadScriptT

    if (typeof window !== "undefined") {
        onMount(async () => {
            let paypal: any
            try {
                paypal = await paypalLoadScript({
                    clientId: paypalMode == "sandbox" ? paypalSandboxClientId : paypalLiveClientId,
                    currency: currency.code,
                })
            } catch (e) {
                console.log("paypal loadScript failed", e)
                errorCode = await reportFrontendError({
                    stage: "sdk-load",
                    provider: "paypal",
                    sdkError: String((e as any)?.message || e).slice(0, 500),
                })
                return
            }

            initialized = true
            ppContainer.innerHTML = ""

            const cartSum = await getAsyncCartSum($cart)

            paypal
                .Buttons({
                    createOrder: (data, actions) => {
                        return postPayment({
                            type: "paypal",
                            cart: $cart,
                            sum: cartSum,
                            vat: $checkoutData.vat,
                            contact: $checkoutData.contact,
                            billingAddress: $checkoutData.billingAddress,
                            deliveryAddress: $checkoutData.deliveryAddress,
                        }).then(
                            (response) => {
                                console.log("PAYPAL ORDER:", response)
                                return response.pay_id
                            },
                            async (e) => {
                                // Server hat bereits geloggt (Code in Antwort); sonst SDK-Fehler melden
                                errorCode =
                                    errorCodeFrom(e) ||
                                    (await reportFrontendError({
                                        stage: "sdk-create",
                                        provider: "paypal",
                                        sdkError: JSON.stringify(e?.data || e).slice(0, 500),
                                    }))
                                throw e
                            }
                        )
                    },
                    onApprove: (data, actions) => {
                        $checkoutData.payment.pay_id = data.orderID
                        return submitHandler().catch(async (e) => {
                            errorCode =
                                errorCodeFrom(e) ||
                                (await reportFrontendError({
                                    stage: "sdk-approve",
                                    provider: "paypal",
                                    sdkError: JSON.stringify(e?.data || e).slice(0, 500),
                                }))
                            // Kein Re-Throw: Box zeigt den Code (sonst unbehandelte Rejection).
                        })
                    },
                    onError: async (e) => {
                        console.log("paypal onError", e)
                        errorCode = await reportFrontendError({
                            stage: "sdk-error",
                            provider: "paypal",
                            sdkError: String((e as any)?.message || JSON.stringify(e)).slice(0, 500),
                        })
                    },
                    onCancel: () => {
                        // Kundenabbruch: kein Fehler, kein Eintrag
                        console.log("paypal onCancel (user abort)")
                    },
                })
                .render("#paypal-button-container")
        })
    }
</script>

<div id="pp">
    <h4>{$_("paypal.order_now")}:</h4>
    <CheckoutErrorBox code={errorCode} />
    {#if !initialized && !errorCode}<BarLoader />{/if}
    <div bind:this={ppContainer} id="paypal-button-container"></div>
</div>

<style>
    #pp {
        width: 400px;
        max-width: 100%;
    }
</style>
